import request from '@/axios/customerManager'

// 01-首页（公海池数据）
export function getIndexHighSeas(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/getIndexHighSeas',
    method: 'post',
    data
  })
}
// 02-公海池列表
export function getHighSeasList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/getHighSeasList',
    method: 'post',
    data
  })
}
// 03-公海池客户详情
export function getHighSeasCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/getHighSeasCustomerInfo',
    method: 'post',
    data
  })
}
// 04-捞单
export function salvageOrdero(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/salvageOrder',
    method: 'post',
    data
  })
}
// 05-公海池预面谈列表
export function getAwaitVisitList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/getAwaitVisitList',
    method: 'post',
    data
  })
}
// 06-客户详情
export function getCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/getCustomerInfo',
    method: 'post',
    data
  })
}
// 07-跟进
export function customerFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/highseas/high_seas/customerFollow',
    method: 'post',
    data
  })
}
// 输单原因标签列表
export function getLoseReasonList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/high_seas/getLoseReasonList',
    method: 'post',
    data
  })
}
// 跟进方式列表
export function getFollowTypeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/high_seas/getFollowTypeList',
    method: 'post',
    data
  })
}
